import { ContentContainer, PageLayout, PageTitle } from "components/layout";

import { FiltersSidebar } from "./components/filters-sidebar";
import { ExtractionHistoryTable } from "./components/extraction-history-table";
import { useTaxClosing } from "./hooks/use-tax-closing";

export const TaxClosing: React.FC = () => {
  const { onGenerate, isCreating } = useTaxClosing();

  return (
    <PageLayout>
      <PageTitle
        title="Extração Fiscal"
        description="Extraia dados fiscais do GFT para conferência e fechamento"
      />
      <ContentContainer>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          <div className="md:col-span-2">
            <FiltersSidebar
              onGenerate={onGenerate}
              isDisabled={isCreating}
              isLoading={isCreating}
            />
          </div>
          <div className="md:col-span-3">
            <ExtractionHistoryTable />
          </div>
        </div>
      </ContentContainer>
    </PageLayout>
  );
};
